import { request } from '../utils/http'

export const getCurrentUser = () => request('/api/user/me')

export const updateUserProfile = (payload) => request('/api/user/profile', {
  method: 'PUT',
  body: payload
})

export const uploadUserAvatar = (file) => {
  const formData = new FormData()
  formData.append('file', file)

  return request('/api/user/avatar', {
    method: 'POST',
    body: formData
  })
}

export const updateUserPassword = (payload) => request('/api/user/password', {
  method: 'PUT',
  body: payload
})

export const getNotificationSetting = () => request('/api/user/notification-setting')

export const updateNotificationSetting = (payload) => request('/api/user/notification-setting', {
  method: 'PUT',
  body: payload
})
